<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="onAdd()"
                    matTooltip="{{ 'new_record_hint' | transloco }}"
                >
                    <mat-icon>add</mat-icon>
                    {{ "new_record" | transloco }}
                </button>
            </div>

            <div class="main-toolbar-spacer"></div>

            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">
                    <div class="filter-item">
                        <ng-container *transloco="let t">
                            <pixl-free-filter-input
                                [label]="t('title_or_id')"
                                [matIcon]="'search'"
                                [hint]="getSearchFilterHint()"
                                [minLength]="freeFilterLen"
                                (onKeyUpChange)="setFreeFilter($event)"
                            />
                        </ng-container>
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>{{ 'application' | transloco }}</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setConsumerFilter($event)"
                            >
                                @for (consumer of consumers$ | async; track consumer) {
                                <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    @if (isAbuConsumerSelected) {
                        <div class="filter-item">
                            <mat-form-field>
                                <mat-label>{{ 'canton' | transloco }}</mat-label>
                                <mat-select
                                    (valueChange)="setCantonFilter($event)"
                                >
                                    <mat-option [value]="null">{{ 'all' | transloco }} {{ 'cantons' | transloco }}</mat-option>
                                    @for (canton of cantonOptions; track canton.name) {
                                    <mat-option [value]="canton.name">{{ canton.label }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    }

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>{{ 'subjects' | transloco }}</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setSubjectFilter($event)"
                            >
                                @for (subject of subjects$ | async; track subject) {
                                <mat-option [value]="subject.name">{{ subject.name }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>


                    <div class="filter-item">
                        <pixl-multi-combo-entity-search
                            [label]="learningUnitLabels"
                            [observable$]="learningUnits$"
                            [namingColumn]="'title'"
                            [externalSearch]="true"
                            (onStateChange)="receiveLearningUnitData($event)"
                            (onSearchChange)="receiveLearningUnitQuery($event)"
                            (scrolledToEnd)="loadMoreLearningUnits($event)"
                            [(selectedValues)]="selectedLearningUnits"
                        >
                        </pixl-multi-combo-entity-search>
                    </div>

                    <div class="filter-item">
                        <pixl-state-cb
                            (onStateChange)="setStatusFilter($event)"
                            [withEmptyOption]="true"
                        />
                    </div>
                </div>
            </div>
            <div class="main-toolbar-spacer-right"></div>
        </div>
        <div class="table-header-overlay"></div>
    </div>

    <div class="table-container mat-elevation-z4">
        @if (modules$ | async; as modules) {
        <table
            mat-table
            [dataSource]="modules"
            matSort
            [trackBy]="trackById"
        >
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "actions" | transloco }}</th>

                <td
                    mat-cell
                    *matCellDef="let module"
                >
                    <button
                        [class.btn-success]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="onEdit(module)"
                        matTooltip="{{ 'edit_record_hint' | transloco }}"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>

                    <button
                        [class.btn-info]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Copy"
                        (click)="onCopy(module)"
                        matTooltip="{{ 'copy_record_hint' | transloco }}"
                    >
                        <mat-icon>content_copy</mat-icon>
                    </button>

                    <button
                        [class.btn-danger]="coloredButtonsEnabled()"
                        mat-icon-button
                        color="warn"
                        aria-label="Delete"
                        (click)="onDelete(module)"
                        matTooltip="{{ 'delete_record_hint' | transloco }}"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>

                    @if (isAbuConsumerSelected && selectedCanton) {
                        <button
                            [class.btn-dark]="coloredButtonsEnabled()"
                            mat-icon-button
                            aria-label="Reorder"
                            (click)="onReorder(module)"
                            matTooltip="{{ 'reorder_record_hint' | transloco }}"
                        >
                            <mat-icon>swap_vert</mat-icon>
                        </button>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="id">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >ID</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >{{ module.id }}</td>
            </ng-container>

            <ng-container matColumnDef="title">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "title" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >{{ module.title }}</td>
            </ng-container>

            <ng-container matColumnDef="preTitle">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "supertitle" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >{{ module.preTitle }}</td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "description" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >
                    {{
                    module.description
                    ? (module.description.length > 50
                    ? (module.description | slice:0:50) + '…'
                    : module.description)
                    : ''
                    }}
                </td>
            </ng-container>

            <ng-container matColumnDef="content">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "content" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >{{ module.content }}</td>
            </ng-container>

            <ng-container matColumnDef="consumer">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "consumer" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >
                    {{ module.consumer?.id && getConsumerName(module.consumer.id) }}
                </td>
            </ng-container>

            <ng-container matColumnDef="kantone">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ 'cantons' | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >
                    @for (label of getKantonLabels(module); track label) {
                    <span class="badge badge-dark me-1">
                        {{ label }}
                    </span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="professions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ 'professions' | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >
                    @for (label of getProfessionLabels(module); track label) {
                    <span class="badge badge-dark me-1">
                        {{ label }}
                    </span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="subjects">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "subjects_professions" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >
                    @for (subjectName of getSubjectNames(module.subjects); track subjectName) {
                    <span class="badge badge-dark me-1">
                        {{ subjectName }}
                    </span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="schoolClasses">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "school_classes" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >
                    @for (className of getSchoolClassNames(module.schoolClasses); track $index) {
                    <span class="badge badge-dark me-1">
                        {{ className }}
                    </span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="learningUnits">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "learning_units" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >
                    @for (unitName of getLearningUnitNames(module.learningUnits); track $index) {
                    <span class="badge badge-dark me-1">
                        {{ unitName }}
                    </span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "state" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >
                    <div class="editstatus">
                        <button
                            class="badge"
                            [ngClass]="getStatusColor(module.status)"
                        >
                            {{ getStatusText(module.status) }}
                        </button>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="created_at">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "created_at" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let module"
                >{{ module.created_at | date }}</td>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.selected-row]="currentSelectedRow() === row.id"
            ></tr>
        </table>
        } @else {
        <pixl-table-loading-spinner [name]="'Modules'" />
        }
        <mat-paginator
            [pageIndex]="pageChange().pageIndex"
            [pageSize]="pageChange().pageSize"
            [pageSizeOptions]="[25, 50, 100]"
            [length]="totalItems">
        </mat-paginator>
    </div>
</div>